import React, { useEffect, useMemo, useState } from "react";
import { Col, Empty, Row, Tag } from "antd";
import { useNavigate } from "react-router";
import LoadingSpin from "../../loadingSpin/LoadingSpin";
import MasterBinService from "../../../services/Shared-Service/MasterBinService";
import "../../../styles/global-ui.css";
import bin_img from "../../../assets/dashboard/bin_img.png";

const normalize = (value) => String(value || "").trim().toLowerCase();

const isGsmTransitBin = (bin) =>
  normalize(bin?.bin_to) === "garment_super_market" &&
  normalize(bin?.movement_status) === "in transit";

const GSM_IntrasitDashboard = () => {
  const [loading, setLoading] = useState(true);
  const [binData, setBinData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await MasterBinService.masterBin_get_bins_details();
        const allBins = Array.isArray(response?.data) ? response.data : [];
        const filteredData = allBins.filter(isGsmTransitBin);

        setBinData(filteredData);
        console.log("Fetched bin details:", filteredData);
      } catch (error) {
        console.error("Error fetching bin details:", error);
        setBinData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleCardClick = (bin) => {
    console.log("Bin clicked:", bin);
    navigate(`/gsm-in-transit/view?binId=${encodeURIComponent(bin.bin_id)}`);
  };

  const totalTransitBins = binData.length;

  const totalTransitPcs = useMemo(() => {
    return binData.reduce(
      (sum, bin) =>
        sum +
        Number(
          bin?.total_quantity ||
            bin?.qty ||
            bin?.quantity ||
            bin?.total_qty ||
            0
        ),
      0
    );
  }, [binData]);

  return (
    <div style={{ position: "relative" }}>
      {loading && (
        <div className="dashboard-overlay-loader">
          <LoadingSpin />
        </div>
      )}

      <div className="compact-stats" style={{ marginBottom: 24 }}>
        <Row gutter={[16, 8]} justify="center">
          <Col xs={24} sm={12}>
            <div className="compact-stat-item">
              <div className="compact-stat-value" style={{ color: "#0f172a" }}>
                {loading ? 0 : totalTransitBins}
              </div>
              <div className="compact-stat-label">Transit Bins</div>
            </div>
          </Col>

          <Col xs={24} sm={12}>
            <div className="compact-stat-item">
              <div className="compact-stat-value" style={{ color: "#0f766e" }}>
                {loading ? 0 : totalTransitPcs}
              </div>
              <div className="compact-stat-label">Transit Pieces</div>
            </div>
          </Col>
        </Row>
      </div>

      {!loading && binData.length > 0 ? (
        <Row gutter={[16, 16]} className="dashboard-card-grid">
          {binData.map((bin) => (
            <Col xs={24} sm={12} md={8} lg={6} xl={5} key={bin.bin_id}>
              <div className="bin-card" onClick={() => handleCardClick(bin)}>
                <div className="bin-card-top">
                  <Tag
                    className="location-badge"
                    style={{
                      background: "#fef9c3",   // light yellow bg
  color: "#854d0e",        // dark yellow/brown text
  borderColor: "#fde68a",  // soft yellow border
  margin: 0,
                    }}
                  >
                    In Transit
                  </Tag>
                </div>

                <div className="bin-card-image-wrap">
                  <img src={bin_img} alt="bin" className="bin-card-image" />
                  <div className="bin-card-name">
                    {bin.bin_name || `Bin ${bin.bin_id}`}
                  </div>
                </div>

                <div className="bin-card-footer">
                  <div
                    className={`pcs-badge ${
                      Number(
                        bin?.total_quantity ||
                          bin?.qty ||
                          bin?.quantity ||
                          bin?.total_qty ||
                          0
                      ) > 0
                        ? "full-badge"
                        : "empty-badge"
                    }`}
                  >
                    {Number(
                      bin?.total_quantity ||
                        bin?.qty ||
                        bin?.quantity ||
                        bin?.total_qty ||
                        0
                    )}{" "}
                    Pcs
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      ) : null}

      {!loading && binData.length === 0 ? (
        <div className="dashboard-loading-wrap">
          <Empty description="No bins in transit for GSM" />
        </div>
      ) : null}
    </div>
  );
};

export default GSM_IntrasitDashboard;